module.exports = __webpack_public_path__ + "static/img/3.937a624.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/3.png
// module id = Lc9P
// module chunks = 0